import React from "react";
import imgTc from "../../assets/sec_training_camp/model_Training_camp.webp";

const AboutTrainingKedinasan = () => {
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <div className="container-about-training-camp">
        <div className="box-text-img-about-training-camp">
          <img
            src={imgTc}
            alt="Bimbel Masuk Akpol Akmil Bintara TNI Polri"
            className="img-about-training-camp"
          />
          <div className="box-text-about-training-camp">
            <h1 className="title-training-camp">TRAINING CAMP {currentYear}</h1>
            <p className="desk-about-training-camp">
              Program Komando Training Camp merupakan program ekslusif karantina
              dengan pola bimbingan belajar dan latihan yang super intensif bagi
              kalian yang akan bersiap masuk Sekolah Kedinasan.
              Dengan fasilitas belajar yang lengkap dan dibimbing oleh Tutor dan
              pelatih profesional serta pola pembinaan yang terjadwal dan
              teratur akan memaksimalkan peningkatan potensi dan kualitas siswa
              sehingga akan lebih siap dan mudah untuk lolos seleksi.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AboutTrainingKedinasan;
